import { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";
import { metaMessageTemplates } from "../../../api/Messages";
import { Link } from "react-router-dom";

export default function MetaWaTemplates() {
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);

  const getMessageTemplates = async () => {
    setLoading(true);
    try {
      const response = await metaMessageTemplates();
      if (response?.data?.data) {
        setTemplates(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMessageTemplates();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card mb-4">
                      <div className="card-body d-flex justify-content-between align-items-center">
                        <h4 className="text-primary m-0">
                          Create Meta Whatsapp Message Template
                        </h4>

                        <Link to="/meta/templates/create" className="btn btn-primary">
                          Create Templates
                        </Link>


                      </div>
                    </div>

                    <div className="row g-4">
                      {templates?.map((template, i) => (
                        <div className="col-sm-4 col-6" key={i}>
                          <div className="card">
                            <div className="card-body">
                              {template?.components?.map((component, i) => (
                                <>
                                  {component?.type === "HEADER" &&
                                    component?.format === "TEXT" && (
                                      <b>{component?.text}</b>
                                    )}
                                  {component?.type === "BODY" && (
                                    <pre className="m-0 fw-normal">
                                      {component?.text}
                                    </pre>
                                  )}
                                  {component?.type === "FOOTER" && (
                                    <b>{component?.text}</b>
                                  )}
                                </>
                              ))}

                              <hr />
                              <b>
                                {template?.name} ({template?.language})
                              </b>
                              <p className="my-1">
                                Category: {template?.category}
                              </p>

                              <span
                                className={`badge ${template?.status === "APPROVED"
                                  ? "bg-success"
                                  : "bg-warning"
                                  } `}
                              >
                                {template?.status}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}
